import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { DetailStore } from '../../services/stores/detail.store';
import { DetailModel } from '../../models/detail.model';
import { List } from 'immutable';
import { UiStateStore } from '../../services/stores/ui-state.store';
import { UiState } from '../../models/ui-state.model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { OrganizationStore } from '../../services/stores/organization.store';
import { OrganizationModel } from '../../models/organization.model';
import { map } from 'rxjs/operators';
@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css'],
  standalone: false,
})
export class DetailComponent implements OnInit {
  username: string = '';
  password: string = '';
  organization: OrganizationModel = new OrganizationModel({});
  organizationForm!: FormGroup;
  showInvalidCredentialMessage = false;
  safeUrl!: SafeResourceUrl;
  selectedValue: string = '';
  ssoProviders: any[] = [];

  constructor(
    public detailStore: DetailStore,
    private organizationStore: OrganizationStore,
    private uiStateStore: UiStateStore,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.createForm();
    this.ssoProviders = ['None', 'Okta'];
    this.organizationStore.$firstOrganization.subscribe((x) => {
      if (x) {
        this.organization = x;
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(x.logoBase64);
        this.organizationForm.setValue({
          allowLocalLogin: x.allowLocalLogin,
          allowThirdPartyLogin: x.allowThirdPartyLogin,
          thirdPartyLoginProvider: x.thirdPartyLoginProvider,
        });
      }
    });
  }
  createForm() {
    this.organizationForm = this.fb.group({
      allowLocalLogin: false,
      allowThirdPartyLogin: false,
      thirdPartyLoginProvider: 'None',
    });
  }

  onSubmit() {
    this.save();
  }

  save() {
    const org = this.prepareSaveOrganization();
    this.uiStateStore.startBackendAction('Updating organization details...');
    this.organizationStore.$updateOrganization(org).subscribe((success) => {
      if (success) {
        this.organizationForm.markAsPristine();
        this.uiStateStore.endBackendAction('Done!');
      }
    });
  }

  prepareSaveOrganization() {
    const formModel = this.organizationForm.value;
    // this.organization.set('allowLocalLogin', formModel.allowLocalLogin);
    //  this.organization.set('allowThirdPartyLogin', formModel.allowThirdPartyLogin);

    var org = this.organization;
    org.allowLocalLogin = true;
    org.allowThirdPartyLogin = true;
    org.thirdPartyLoginProvider = formModel.thirdPartyLoginProvider;
    return org;
  }

  get organizationCount() {
    return this.organizationStore.$organizations.pipe(map((organizations: List<OrganizationModel>) => organizations.size));
  }
  get detailCount() {
    return this.detailStore.$details.pipe(map((details: List<DetailModel>) => details.size));
  }
  get uiStateMessage() {
    return this.uiStateStore.$uiState.pipe(map((uiState: UiState) => uiState.message));
  }
}
